import React, { useState } from "react";
import { TextField, MenuItem, Button, Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const StepRegister = ({
  fullName,
  age,
  gender,
  mobile,
  emailId,
  genders,
  setFullName,
  setAge,
  setGender,
  setMobile,
  setEmailId,
  handleCreateAccount,
  loading,
}) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!fullName.trim()) newErrors.fullName = "Full name is required";
    if (!age || isNaN(age) || Number(age) <= 0)
      newErrors.age = "Valid age is required";
    if (!gender) newErrors.gender = "Gender is required";
    if (!mobile || !/^\d{7,15}$/.test(mobile))
      newErrors.mobile = "Valid mobile number is required";
    if (emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailId))
      newErrors.emailId = "Invalid email address";
    return newErrors;
  };

  const handleSubmit = () => {
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      handleCreateAccount();
    }
  };

  return (
    <>
      <Box textAlign="center" mb={1}>
        <PersonIcon fontSize="large" color="primary" />
      </Box>
      <h2>Create your account</h2>

      <TextField
        fullWidth
        label="Full Name"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        margin="normal"
        size="small"
        error={!!errors.fullName}
        helperText={errors.fullName}
      />

      <Box display="flex" gap={2} my={2}>
        <TextField
          fullWidth
          label="Age"
          value={age}
          onChange={(e) => setAge(e.target.value)}
          size="small"
          error={!!errors.age}
          helperText={errors.age}
        />
        <TextField
          select
          fullWidth
          label="Gender"
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          size="small"
          error={!!errors.gender}
          helperText={errors.gender}
        >
          {genders.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <TextField
        fullWidth
        label="Mobile"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
        margin="normal"
        size="small"
        error={!!errors.mobile}
        helperText={errors.mobile}
      />

      <TextField
        fullWidth
        label="Email (optional)"
        value={emailId}
        onChange={(e) => setEmailId(e.target.value)}
        margin="normal"
        size="small"
        error={!!errors.emailId}
        helperText={errors.emailId}
      />

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        {loading ? "Loading..." : "Create Account"}
      </Button>
    </>
  );
};

export default StepRegister;
